<template>
  <div class="sso-body">
    <Toast/>
    <Dialog :header="$t('login.changepassword')" :visible="showChangeDialog" :style="{'max-width': '30em'}"
            :closable="false" :modal="true" :draggable="false">
      <div class="grid change-password-box">
        <div class="col-12">
        <span class="p-float-label">
                      <Password autocomplete="new-password" toggleMask v-model="newPassword"/>
                      <label>{{ $t('login.newpassword') }}</label>
        </span>
        </div>
        <div class="col-12" style="margin-top: 1em">
        <span class="p-float-label">
                      <Password autocomplete="new-password" toggleMask v-model="confirmNewPassword"/>
                      <label>{{ $t('login.confirmnewpassword') }}</label>
        </span>
        </div>
      </div>
      <template #footer>
        <Button :disabled="loading" icon="pi pi-check" :label="$t('common.buttons.save')" @click="changePassword"/>
      </template>
    </Dialog>

    <div class="box">
      <div class="grid">
        <div class="col-12 md:col-5">
          <img class="animation" src="assets/layout/images/logo-coface-RVB.png" alt="logo-coface-RVB"
               :style="($vssWidth > 767 ? 'margin-bottom: 2em; height: 5em; float: right' : 'margin-bottom: 2em; height: 5em;')"/>
        </div>
        <div class="col" style="text-align: center">
          <h2 class="sso-text">: SSO</h2>
          <h2 class="auth-text">-AUTHENTICATION</h2>
        </div>
      </div>
      <div class="grid center">
        <div class="point animation-point"></div>
        <div class="point animation-point"></div>
        <div class="point animation-point"></div>
        <div class="point animation-point"></div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginService from '../service/LoginService';
import jwt_decode from 'jwt-decode';
import gsap from 'gsap';
import { VueScreenSizeMixin } from 'vue-screen-size';
import { isEmpty } from '@/main';

export default {
  mixins: [VueScreenSizeMixin],
  created() {
    this.loginService = new LoginService();
  },
  beforeMount() {
    this.$store.dispatch("stopLoading");
    if(!this.checkReset()){
      this.showSsoLoading = true
      this.checkSsoSession();
    }
    this.animation()
  },
  data() {
    return {
      showChangeDialog: false,
      username:null,
      password: null,
      newPassword: null,
      confirmNewPassword: null,
      showSsoLoading: false
    }
  },
  computed: {
    loading() {
      return this.$store.state.loading > 0;
    },
    userInStore() {
      return this.$store.getters["user"]
    }
  },
  methods: {
    animation() {
      this.tl = gsap.timeline({repeat: -1});
      this.tl.from('.animation-point', {
        duration: .6,
        opacity: 0,
        scale: 0,
        ease: 'power1',
        stagger: {
          each: 0.1,
          from: 'left'
        }
      })
      this.tl.to('.animation-point', {
        duration: .6,
        scale: 0,
        opacity: 0,
        ease: 'power1',
        stagger: {
          each: 0.1,
          from: 'left'
        }
      }, .6)
    },
    userData(data) {
      let jwtDecoded = jwt_decode(data.jwt);
      let user = {
        username: jwtDecoded.upn,
        token: data.jwt,
        refresh: data.refresh,
        roles: jwtDecoded.groups.filter(role => role.includes('selectio')).map(role => role.split(':')[1])
      };
      this.$store.commit("setUser", user);
      this.loginService.getUserData().then(userData => {
        this.$store.dispatch('stopLoading');
        user = this.loginService.mapUserDataToUser(userData, user);
        this.$store.dispatch('login', { vm: { vm: this }, user: user });
        let count = 0;
        if (user.selectioEnabled === true) count++;
        if (user.cofastEnabled === true) count++;
        if (user.lensEnabled === true) count++;
        if (count > 1) {
          this.$router.push('/landing-page');
        } else if (count === 1 && user.selectioEnabled === true) {
          this.$endpoints.goToSelectio(user, this.$router, this.$store, this);
        } else if (count === 1 && user.cofastEnabled === true) {
          this.$endpoints.goToCofast();
        } else if (count === 1 && user.lensEnabled === true) {
          this.$endpoints.goToLens();
        } else {
          this.$toast.add({
            severity: this.$t('common.toasts.loginError.severity'),
            summary: this.$t('common.toasts.loginError.summary'),
            detail: this.$t('common.toasts.loginError.detail'),
            life: 60000,
          });
        }
      }).catch(e => {
        this.$toast.add({
          severity: this.$t('common.toasts.loginError.severity'),
          summary: this.$t('common.toasts.loginError.summary'),
          detail: this.$t('common.toasts.loginError.detail'),
          life: 60000,
        });
        this.$store.dispatch('resetLoading');
        throw e;
      });
    },
    redirectToSsoHomepage(){
      this.loginService.getSsoHomepage().then(url => {
        window.location.replace(url);
      })
    },
    loginFromSso(actionId){
        this.loginService.consumeSsoAction(actionId).then(tokens => {
          this.userData(tokens);
        })
    },
    checkSsoSession(){
      const actionId = this.$route.query.actionId;
      const jwt = this.$route.query.jwtSso;
      const refresh =this.$route.query.refresh;
      if (!isEmpty(actionId)) this.loginFromSso(actionId);
      if (!isEmpty(jwt)) this.userData({ jwt: jwt, refresh:refresh });
      if (isEmpty(actionId) && isEmpty(jwt)) this.redirectToSsoHomepage();
    },
    login(user) {
      if (user != null && user.username != null && user.password != null) {
        this.username = user.username;
        this.password = user.password;
      }
      this.loginService.doLogin(this.username, this.password).then(data => {
        this.$store.dispatch("stopLoading");
        if (data != null && data.message == null) {
          this.userData(data)
        } else if (data != null) {
          this.$toast.add({
            severity: this.$t("common.toasts." + data.message + ".severity"),
            summary: this.$t("common.toasts." + data.message + ".summary"),
            detail: this.$t("common.toasts." + data.message + ".detail"),
            life: 60000
          });
        }
      }).catch(e => {
        this.$store.dispatch("resetLoading");
        this.$toast.add({
          severity: "error",
          summary: this.$t("common.toasts.loginError.summary"),
          detail: this.$t("common.toasts.loginError.detail"),
          life: 60000
        });
        console.log("error authenticating", e);
      });
    },
    checkReset(){
      const tokenReset = this.$route.query["reset"]
      if(tokenReset != null){
        const tokenData = JSON.parse(atob(tokenReset))
        this.username = tokenData.u
        this.password = tokenData.p
        this.showChangeDialog = true
        return true;
      }
      return false
    },
    changePassword() {
      const user = {username:this.username,password: this.password,newPassword:this.newPassword,confirmNewPassword:this.confirmNewPassword}
      if (user.username == null || user.password == null || user.newPassword == null || user.confirmNewPassword == null) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("common.toasts.changePasswordNullField.summary"),
          detail: this.$t("common.toasts.changePasswordNullField.detail"),
          life: 60000
        });
      } else if (user.newPassword !== user.confirmNewPassword) {
        this.$toast.add({
          severity: "warn",
          summary: this.$t("common.toasts.changePasswordNotEquals.summary"),
          detail: this.$t("common.toasts.changePasswordNotEquals.detail"),
          life: 60000
        });
      } else {
        this.loginService.changePassword(user).then((data) => {
          this.$toast.add({
            severity: this.$t("common.toasts."+data+".severity"),
            summary: this.$t("common.toasts."+data+".summary"),
            detail: this.$t("common.toasts."+data+".detail"),
            life: 60000
          });
          if(data === 'VALID'){
            user.password = this.newPassword
            this.login(user)
          }
        }).catch(e => {
          this.$toast.add({
            severity: "error",
            summary: this.$t("common.toasts.changePasswordError.summary"),
            detail: this.$t("common.toasts.changePasswordError.detail"),
            life: 60000
          });
          console.log("error changePassword", e);
        });
      }
    },
  },
  loginService: null,
}
</script>

<style lang="scss" scoped>

</style>
